import {get,post} from './httpApi';
import {getUserId} from '@/utils/auth'
/*用户注册*/
export function register(data=null){
    return post('/user/noJwt/register',data)
}

/*客户登陆*/
export function login(data){
    return post('/user/noJwt/login',data)
}
/*客户验证码登陆*/
export function loginByCode(data){
    return post('/user/noJwt/loginByCode',data)
}
/*根据手机验证码修改密码*/
export function editPassword(data){
    return post('/user/noJwt/editPassword',data)
}
/**
 * 根据手机验证码修改支付密码
 * @param phone
 * @param password
 * @param code
 * @return
 */
export function editPayPassword(data){
    return post('/user/editPayPassword',data)
}
export function getMeInfo(userId=null){
    return get('/user/getMeInfo',{
        userId:userId||getUserId()
    })
}
export function userEdit(data=null){
    return post('/user/edit',data)
}
/*用户获取余额流水*/
export function getUserMoneyLog(data=null){
    return get('/userRechargeLog/getUserMoneyLog',{
        ...data,
        userId:getUserId()
    })
}

/*显示用户地址列表*/
export function getUserAddressList(data=null){
    return get('/user/getUserAddressList',data)
}
/*添加地址*/
export function addAddress(data=null){
    return post('/user/addAddress',data)
}
/*修改地址*/
export function editAddress(data=null){
    return post('/user/editAddress',data)
}
/*删除地址*/
export function delAddress(data=null){
    return get('/user/delAddress',data)
}
/*用户实名认证*/
export function setUserReal(data=null){
    return post('/user/setUserReal',data)
}
